import { defineMessage } from '@lingui/macro';

export const CrewMemberShiftTypeMessages = {
  DAY: defineMessage({ message: 'Day', id: 'Day' }),
  NIGHT: defineMessage({ message: 'Night', id: 'Night' }),
};

export const MilestoneStatusMessages = {
  UNCLAIMED: defineMessage({ message: 'Unclaimed', id: 'Unclaimed' }),
  CLAIMED: defineMessage({ message: 'Claimed', id: 'Claimed' }),
  APPROVED: defineMessage({ message: 'Approved', id: 'Approved' }),
  UNAPPROVED: defineMessage({ message: 'Unapproved', id: 'Unapproved' }),
  REJECTED: defineMessage({ message: 'Rejected', id: 'Rejected' }),
  BLOCKED: defineMessage({ message: 'Blocked', id: 'Blocked' }),
  PLANNED: defineMessage({ message: 'Planned', id: 'Planned' }),
  UNPLANNED: defineMessage({ message: 'Unplanned', id: 'Unplanned' }),
  BLOCK_RESOLVED: defineMessage({ message: 'Block Resolved', id: 'Block Resolved' }),
};

const READY_TO_WELD = 'READY_TO_WELD',
  VT_SENT_BACK = 'VT_SENT_BACK',
  BLOCKED = 'BLOCKED',
  FITUP_INSPECTION = 'FITUP_INSPECTION',
  CLAIMED = 'CLAIMED',
  ASSIGNED = 'ASSIGNED',
  VT_APPROVED = 'VT_APPROVED',
  SENT_BACK_TO_PIPING = 'SENT_BACK_TO_PIPING',
  UNPLANNED = 'UNPLANNED',
  UNASSIGNED = 'UNASSIGNED',
  FITUP_REQUESTED = 'FITUP_REQUESTED';

export const WeldStatusMessages = {
  [READY_TO_WELD]: defineMessage({ message: 'Ready to Weld', id: 'READY_TO_WELD' }),
  [VT_SENT_BACK]: defineMessage({ message: 'VT Sent Back', id: 'VT_SENT_BACK' }),
  [BLOCKED]: defineMessage({ message: 'Blocked', id: 'BLOCKED' }),
  [FITUP_REQUESTED]: defineMessage({ message: 'Fitup Requested', id: 'FITUP_REQUESTED' }),
  [FITUP_INSPECTION]: defineMessage({ message: 'Fitup Inspection', id: 'FITUP_INSPECTION' }),
  [CLAIMED]: defineMessage({ message: 'Claimed', id: 'CLAIMED' }),
  [ASSIGNED]: defineMessage({ message: 'Assigned', id: 'ASSIGNED' }),
  [VT_APPROVED]: defineMessage({ message: 'VT Approved', id: 'VT_APPROVED' }),
  [SENT_BACK_TO_PIPING]: defineMessage({ message: 'Sent Back to Piping', id: 'SENT_BACK_TO_PIPING' }),
  [UNPLANNED]: defineMessage({ message: 'Unplanned', id: 'UNPLANNED' }),
  [UNASSIGNED]: defineMessage({ message: 'Unassigned', id: 'UNASSIGNED' }),
};

export const FitupStatsSummaryMessage = {
  [FITUP_REQUESTED]: defineMessage({ message: 'Fitup Requested', id: 'Fitup Requested' }),
  [FITUP_INSPECTION]: defineMessage({ message: 'Claimed', id: 'Claimed' }),
  [SENT_BACK_TO_PIPING]: defineMessage({ message: 'Rejected', id: 'Rejected' }),
  [READY_TO_WELD]: defineMessage({ message: 'Approved', id: 'Approved' }),
};

export const InstallStatsSummaryMessage = {
  [CLAIMED]: defineMessage({ message: 'Claimed', id: 'Claimed' }),
  [VT_SENT_BACK]: defineMessage({ message: 'Rejected', id: 'Rejected' }),
  [VT_APPROVED]: defineMessage({ message: 'Approved', id: 'Approved' }),
};
